import React from 'react'
import styled, { keyframes } from 'styled-components'

import vuArrow from '../../../images/vu/vu-arrow.png'

const getInt = (min, max) => {
  const l = Math.ceil(min)
  const u = Math.floor(max)
  return Math.floor(Math.random() * (u - l + 1)) + l
}

const anim = keyframes`
	0% {
    transform: rotate(0deg);
  }

  2% {
    transform: rotate(${getInt(45,85)}deg);
  }

  10% {
    transform: rotate(0deg);
  }

  12% {
    transform: rotate(${getInt(45,80)}deg);
  }

  22% {
    transform: rotate(0deg);
  }

  24% {
    transform: rotate(${getInt(35,85)}deg);
  }

  47% {
    transform: rotate(0deg);
  }

  49% {
    transform: rotate(${getInt(55,85)}deg);
  }

  55% {
    transform: rotate(0deg);
  }

  57% {
    transform: rotate(${getInt(5,85)}deg);
  }

  70% {
    transform: rotate(0deg);
  }

  72% {
    transform: rotate(${getInt(5,85)}deg);
  }

  90% {
    transform: rotate(0deg);
  }

  92% {
    transform: rotate(${getInt(5,85)}deg);
  }

  100% {
    transform: rotate(0deg);
  }
`

const Img = styled.img`
	transform-origin: 50% 73%;
	transform: rotate(0deg);
	animation: ${anim} 5s linear infinite;
	transition-duration: 0.1s;
`

const VuArrow = () => <Img id="loader-arrow" src={vuArrow} alt="loading"/>

// duration: 0.1s - 1s
// rotation: 5 - 85
// delay: 20 - 300

export default VuArrow


// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/loader/LoaderArrow.js